<div class="flex flex-col h-full tk-panel-bg">
  <div class="overflow-y-auto" style="height: calc(100vh - 300px)">
    <table id="data" mat-table matSort recycleRows [dataSource]="dataSource" class=" w-full shadow-none px-4 relative">

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox id="select-all" (change)="$event ? onSelectAll() : null"
                        [checked]="isAllChecked"
                        [indeterminate]="isIndeterminateChecked">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox (click)="$event.stopPropagation()"
                        (change)="$event ? selectionModel.toggle(row) : null"
                        [checked]="selectionModel.isSelected(row)">
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'labels.name' | translate | titlecase}}</th>
        <td mat-cell *matCellDef="let item" class="break-all">{{item.name}}</td>
      </ng-container>

      <ng-container matColumnDef="endDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'labels.status' | translate | titlecase}}</th>
        <td mat-cell *matCellDef="let item">
          <div class="flex items-center">
            <span [ngClass]="{'tk-bg-green-2': item.isActive, 'tk-bg-red': !item.isActive}"
                  class="w-2 h-2 rounded-full mr-2"></span>
            <span [ngClass]="{'tk-c-green-2': item.isActive, 'tk-c-red': !item.isActive}">
              {{(item.isActive ? activeTranslation : inactiveTranslation) | titlecase}}
            </span>
            <span *ngIf="item.isActive" class="ml-1 tk-c-green-2">
              <ng-container *ngIf="item.endDate; else alwaysTemp">{{item.endDate | date: 'short'}}</ng-container>
              <ng-template #alwaysTemp>{{'labels.always' | translate}}</ng-template>
            </span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="vehicles">
        <th mat-header-cell *matHeaderCellDef>{{'labels.vehicles' | translate | titlecase}}</th>
        <td mat-cell *matCellDef="let item">
          <div class="flex items-center">
            <div *ngIf="item.isFullVehiclesLoading; else vehiclesTemp"
                 class="px-4 rounded-2xl tk-c-gray-9 tk-bg-gray-9-alpha-10 h-6 flex items-center">
              {{'labels.loading-data' | translate}}
            </div>
            <ng-template #vehiclesTemp>
              <span *ngFor="let vehicle of item.fullVehicles.slice(0, showVehiclesCount)"
                    class="rounded-2xl mr-2 bg-transparent tk-bg-blue-alpha-10 tk-c-blue h-6 flex items-center">
                <span class="mx-4">{{item.getVehicleShortName(vehicle.Nm, 25)}}</span>
              </span>
            </ng-template>

            <span *ngIf="item.fullVehicles.length > showVehiclesCount"
                  class="flex justify-center items-center w-auto h-6 rounded-full text-center text-xs tk-bg-blue text-white ">
            <span class="ml-1 mr-2">+{{item.fullVehicles.length - showVehiclesCount}}</span>
          </span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="url">
        <th mat-header-cell *matHeaderCellDef>{{'data-sharing.column-link' | translate}}</th>
        <td mat-cell *matCellDef="let item">
         <span class="flex items-center">
            <sm-copy-to-clipboard [data]="item?.url" class="mr-2"
                                  (click)="$event.stopPropagation()"></sm-copy-to-clipboard>
            <span class="tk-c-gray-9 cursor-pointer" (click)="$event.stopPropagation(); onOpenLink(item)">
              mycar.tekom.pl/share...
            </span>
          </span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" class="tk-panel-bg"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" class="cursor-pointer"
          (click)="onRowSelected(row)"></tr>

      <tr class="mat-row" *matNoDataRow>
        <td clas="mat-cell" colspan="5">
          <div class="ml-5 text-sm font-bold">
            <span *ngIf="isLoading; else noDataTemp">{{'labels.loading-data' | translate}}</span>
            <ng-template #noDataTemp>
              <span>{{'labels.no-data' | translate}}</span>
            </ng-template>
          </div>
        </td>
      </tr>
    </table>
  </div>

  <div class="justify-self-start flex items-center ml-3 my-2 text-base">
    <div class="ml-2 mr-4">
      {{this.selectionModel.selected.length}}<span class="ml-1">{{'labels.selected' | translate}}</span>
    </div>

    <app-button id="remove" [isActive]="isRemoveActive" [isFullWidth]="true" innerTextClasses="mx-3"
                label="{{'labels.remove' | translate | titlecase}}" (click)="onRemove()">
    </app-button>
  </div>

</div>

